import HTTP from '@rocketfid/api'

const state = {
  items: []
}

// getters
const getters = {
  kpis: (state) => {
    return state.items
  },
  getById: (state) => (id) => {
    return state.items.find(item => (item.id === id))
  }
}

// actions
const actions = {
  loadKpis ({ commit, dispatch, rootGetters }) {
    let sitekey = rootGetters['account/currentSitekey']

    return HTTP
      .setInstance(sitekey)
      .kpi.getAll()
      .then((kpis) => {
        dispatch('kpis/resetKpis', null, { root: true })
        commit('ADD_KPI_ITEMS', { items: kpis })
        return kpis
      })
  },

  resetKpis ({ commit }) {
    return new Promise((resolve) => {
      commit('RESET_KPI_ITEMS')
      resolve()
    })
  },

  addKpi ({ commit, rootGetters }, { kpi }) {
    let sitekey = rootGetters['account/currentSitekey']

    kpi.typeactions = kpi.actions
    kpi.totalactions = kpi.total

    return HTTP
      .setInstance(sitekey)
      .kpi.create(kpi)
      .then((kpi) => {
        commit('ADD_KPI_ITEM', { item: kpi })
        return kpi
      })
  },

  updateKpi ({ commit, rootGetters }, { kpi }) {
    let sitekey = rootGetters['account/currentSitekey']

    kpi.typeactions = kpi.actions
    kpi.totalactions = kpi.total

    return HTTP
      .setInstance(sitekey)
      .kpi.update(kpi)
      .then((kpi) => {
        commit('UPDATE_KPI_ITEM', { item: kpi })
        return kpi
      })
  },

  removeKpi ({ commit, rootGetters }, { kpi }) {
    let sitekey = rootGetters['account/currentSitekey']

    return HTTP
      .setInstance(sitekey)
      .kpi.delete(kpi)
      .then((kpi) => {
        commit('REMOVE_KPI_ITEM', { item: kpi })
        return kpi
      })
  }
}

// mutations
const mutations = {
  ADD_KPI_ITEMS: (state, { items }) => {
    state.items.push(...items)
  },

  RESET_KPI_ITEMS: (state) => {
    state.items = []
  },

  ADD_KPI_ITEM: (state, { item }) => {
    state.items.push(item)
  },

  UPDATE_KPI_ITEM: (state, { item }) => {
    for (let i = 0; i < state.items.length; i++) {
      if (state.items[i].id === item.id) {
        Object.assign(state.items[i], item)
      }
    }
  },
  REMOVE_KPI_ITEM: (state, { item }) => {
    for (let i = 0; i < state.items.length; i++) {
      if (state.items[i].id === item.id) {
        return state.items.splice(i, 1)
      }
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/kpis.js